<template>
    <div class="page-box">
      <Header/>
      <div class="mg-bottom-70 bg-color-EAF1FA">
        <TopBanner :top-banner-img="BannerImg" title2="B2C零售商城" title-row1="全行业全场景的私域经营，精细化经营" title-row2="会员，高效获取社交电商的" blue-text="生意增量" :title-tips-list="titleTipsList" :contentStype="{paddingTop: '136px'}">
          <div class="top-banner-tips">
            <div class="top-banner-tips-item">自有品牌垂直商城</div>
            <div class="top-banner-tips-item">大型线下门店</div>
            <div class="top-banner-tips-item">传统线下渠道</div>
          </div>
        </TopBanner>
      </div>
      <div class="image-text pd-bottom-90">
        <ModuleCenter data-aos="fade-up">
            <div class="image-text-item" style="margin-bottom: 60px;">
              <div class="image-text-item-left" :style="{ backgroundImage: `url(${imgText1})` }">
                <div class="title-text">消费者</div>
                <div class="title-text" style="margin-bottom: 15px;">数字化经营挑战</div>
                <div>消费市场的供需变化，对零售企业的经</div>
                <div>营增长呈现巨大压力</div>
              </div>
              <div class="flex-box" style="flex: 1;">
                <CardItem v-for="(item, index) in painList.slice(0, 3)" :key="index" :item="item" :cardStyle="cardStyle"></CardItem>
              </div>
            </div>
            <div class="image-text-item">
              <div class="image-text-item-left" :style="{ backgroundImage: `url(${imgText2})` }">
                <div class="title-text">零售渠道
                  </div>
                <div class="title-text" style="margin-bottom: 15px;">数字化经营挑战</div>
                <div>企业内部庞大的销售网络和业务组织，</div>
                <div>让数字化业务推行受阻、收效甚微</div>
              </div>
              <div class="flex-box" style="flex: 1;">
                <CardItem v-for="(item, index) in painList.slice(3, 6)" :key="index" :item="item" :cardStyle="cardStyle"></CardItem>
              </div>
            </div>
        </ModuleCenter>
      </div>
      <!-- 零售商城具备完善的服务能力 -->
      <div class="barrier-background serviceability pd-top-70 bg-color-0B4FD1" style="height: 710px;" :style="{backgroundImage: 'url('+ BgBlue +')'}">
          <ModuleTitle data-aos="fade-up" titleColor="#fff" title="零售商城具备完善的服务能力" />
          <ModuleCenter >
            <div class="flex-box" data-aos="fade-up">
              <CardItem v-for="(item, index) in serviceabilityList" :key="index" :item="item" :cardStyle="serviceabilityStyle"></CardItem>
            </div>
          </ModuleCenter>
      </div>
      <!-- 推广获客：客户在哪里，店就开到哪里 -->
      <div class="goods-manage pd-top-70" style="margin-bottom: 100px;">
        <ModuleTitle data-aos="fade-up" title="推广获客：客户在哪里，店就开到哪里" />
        <ModuleCenter>
          <div class="flex-box justify-center-start" data-aos="fade-up">
            <div class="goods-manage-middle">
              <img class="goods-manage-mid-img-w738" src="@/assets/product/digitalSystem/retailMall-1.png" alt="" />
            </div>
            <div class="goods-manage-right goods-manage-item">
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">海量曝光</span>
                  <div>打通微信、微博、公众号等10+推广渠道，获得海量曝光</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">快速搭建</span>
                  <div>无需技术开发，快速搭建小程序商城</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content">
                  <span class="item-ilne-title">边播边卖</span>
                  <div>集预热、互动、购物、裂变营销为一体，使用微信直播卖货，边播边卖</div>
                </div>
              </div>
            </div>
          </div>
        </ModuleCenter>
      </div>
      <!-- 会员体系打造 等级成长持续活跃 -->
      <div class="barrier-background pd-top-70" style="height: 680px;background-color: #F4F5FB">
          <ModuleTitle data-aos="fade-up" title="会员体系打造 等级成长持续活跃" />
          <ModuleCenter >
            <div class="flex-box" data-aos="fade-up">
              <div class="active-item">
                <div class="active-item-title">构筑科学会员成长体系</div>
                <div class="active-item-desc">灵活等级会员卡配置，支持单等级 / 多等级会员体系设置，</div>
                <div class="active-item-desc">激发用户活跃度积累更多忠实会员</div>
                <img class="active-item-img" src="@/assets/product/digitalSystem/active-1.png" alt="" />
              </div>
              <div class="active-item">
                <div class="active-item-title">会员积分系统促活</div>
                <div class="active-item-desc">用户通过签到、消费、游戏等行为获取积分，用于福利兑换，</div>
                <div class="active-item-desc">提升客户活跃和忠诚度</div>
                <img class="active-item-img" src="@/assets/product/digitalSystem/active-2.png" alt="" />
              </div>
            </div>
          </ModuleCenter>
      </div>
      <!-- 会员深度洞察 精细运营定向营销 -->
      <div class="barrier-background pd-top-70" style="height: 680px;">
          <ModuleTitle data-aos="fade-up" title="会员深度洞察 精细运营定向营销" />
          <ModuleCenter >
            <div class="flex-box" data-aos="fade-up">
              <div class="active-item border-shadow">
                <div class="active-item-title">客户打标精细运营</div>
                <div class="active-item-desc">灵活预置标签内容，设置多种打标方案，</div>
                <div class="active-item-desc">个性化运营提升用户好感度</div>
                <img class="active-item-img" src="@/assets/product/digitalSystem/active-3.png" alt="" />
              </div>
              <div class="active-item border-shadow">
                <div class="active-item-title">用户分群差异管理</div>
                <div class="active-item-desc">交易信息、客户标签、行为信息等多种维度的条件筛选，</div>
                <div class="active-item-desc">圈定不同客户群进行差异化管理</div>
                <img class="active-item-img" src="@/assets/product/digitalSystem/active-4.png" alt="" />
              </div>
            </div>
          </ModuleCenter>
      </div>
      <!-- 数十种营销玩法，吸粉裂变促转化 -->
      <div class="goods-manage pd-top-70" style="height: 780px;background-color: #F4F5FB">
        <ModuleTitle data-aos="fade-up" title="数十种营销玩法，吸粉裂变促转化" subTitle="大转盘、拼团、秒杀的等多种营销活动刺激客户购买，带动商家业绩增长提效" />
        <ModuleCenter>
          <div class="flex-box justify-center-start" data-aos="fade-up">
            <div class="goods-manage-middle">
              <img class="goods-manage-mid-img" style="width: 801px;height: 494px;margin-right: 63px;" src="@/assets/product/digitalSystem/retailMall-2.png" alt="" />
            </div>
            <div class="goods-manage-right goods-manage-item" style="padding-top: 107px;">
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt=""  >
                <div class="item-ilne-content" style="width: auto;">
                  <span class="item-ilne-title">互动营销</span>
                  <div>趣味游戏吸粉裂变，提升活跃度和留存率</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt=""  >
                <div class="item-ilne-content" style="width: auto;">
                  <span class="item-ilne-title">促销工具</span>
                  <div>激发用户购买热情，提高客单价及转化率</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt=""  >
                <div class="item-ilne-content" style="width: auto;">
                  <span class="item-ilne-title">内容营销</span>
                  <div>通过文字、视频、直播互动等形式刺激成交</div>
                </div>
              </div>
            </div>
          </div>
        </ModuleCenter>
      </div>
      <div class="Carousel pd-top-70 pd-bottom-100">
        <ModuleTitle data-aos="fade-up" title="一键美化，轻松运营！打造专属您的线上商城！" />
        <ModuleCenter data-aos="fade-up">
          <div class="Carousel-item" style="margin-bottom: 70px;">
            <div class="Carousel-item-left">
              <div class="Carousel-item-title">行业定制化模板库，让您的平台脱颖而出！</div>
              <div class="goods-manage-ilne mg-bottom-50">
                <img class="item-ilne-icon" :src="CancelImg" alt="" style="margin-right: 15px;">
                <div class="item-ilne-content" style="width: 424px;">
                  <span class="item-ilne-title">一触即发的页面模板</span>
                  <div>丰富的页面模板库，涵盖各个行业的特色需求。每一款模板都精心设计，以满足不同行业的独特风格</div>
                </div>
              </div>
              <div class="goods-manage-ilne mg-bottom-50">
                <img class="item-ilne-icon" :src="CancelImg" alt="" >
                <div class="item-ilne-content" style="width: 424px;">
                  <span class="item-ilne-title">活动氛围，随心所欲</span>
                  <div>节日促销、季节变换，紧跟市场节奏，为您提供与节日氛围相匹配的页面设计</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt=""  >
                <div class="item-ilne-content" style="width: 424px;">
                  <span class="item-ilne-title">傻瓜式操作，运营无忧</span>
                  <div>告别复杂的后台操作，搭建变得前所未有的简单。选择模板、拖拽组件、填充内容，三步轻松完成，实现高效运营</div>
                </div>
              </div>
            </div>
            <div class="Carousel-right">
              <el-carousel height="550px">
                <el-carousel-item v-for="(item, index) in CarouselList" :key="index">
                  <img class="Carousel-img" :src="item.url" alt="">
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <div class="Carousel-item">
            <div class="Carousel-right">
              <img class="Carousel-img" src="@/assets/product/digitalSystem/Carousel-4.png" alt="">
            </div>
            <div class="Carousel-item-left">
              <div class="Carousel-item-title">无限素材库，让您的平台更加生动！</div>
              <div class="goods-manage-ilne mg-bottom-50">
                <img class="item-ilne-icon" :src="CancelImg" alt=""  >
                <div class="item-ilne-content" style="width: 424px;">
                  <span class="item-ilne-title">海量素材，包罗万象</span>
                  <div>图标、海报、宣传图片、宣传视频...覆盖了所有您需要的营销元素。高质量的视觉设计，涵盖各行各业，适配各类营销场景</div>
                </div>
              </div>
              <div class="goods-manage-ilne mg-bottom-50">
                <img class="item-ilne-icon" :src="CancelImg" alt="" >
                <div class="item-ilne-content" style="width: 424px;">
                  <span class="item-ilne-title">一键应用，创意无限</span>
                  <div>一键即可应用于商城页面，从静态图文到动态视频，多样化的选择让创意无处不在</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="" >
                <div class="item-ilne-content" style="width: 424px;">
                  <span class="item-ilne-title">智能搭配，效率翻倍</span>
                  <div>根据您的行业特性和活动主题，智能推荐最匹配的素材组合。节省时间的同时，保障了专业的审美呈现</div>
                </div>
              </div>
            </div>
          </div>
        </ModuleCenter>
      </div>
      <Footer/>
    </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import TopBanner from './components/topBanner.vue'
import Banner from '@/assets/product/digitalSystem/banner-4.jpg'
import ModuleTitle from './components/moduleTitle.vue'
import ModuleCenter from './components/moduleCenter.vue'
import CardItem from './components/cardItem.vue'
import IMBanner1 from '@/assets/product/digitalSystem/integration-module-banner-1.png'
import Cancel from '@/assets/product/digitalSystem/cancel-icon.png'
import ModuleBgBlue from './components/moduleBgBlue.vue'
import OneStopBanner from '@/assets/product/digitalSystem/One-Stop-banner.png'
import SimpleCance from '@/assets/home/check.svg'
import imgText1 from '@/assets/product/digitalSystem/img-text-1.png'
import imgText2 from '@/assets/product/digitalSystem/img-text-2.png'
import BgBlue from '@/assets/product/bg-blue.png'
export default {
  components: {
    Header,
    Footer,
    TopBanner,
    ModuleTitle,
    ModuleCenter,
    CardItem,
    IMBanner1,
    ModuleBgBlue
  },
   data() {
      return {
        CancelImg: Cancel,
        BgBlue: BgBlue,
        imgText1: imgText1,
        imgText2: imgText2,
        BannerImg: Banner,
        titleTipsList: [
          {
            name: '极速部署：无需技术开发，快速搭建小程序商城'
          },
          {
            name: '打通微信、微博、视频号等10+推广渠道，获得海量曝光'
          },
          {
            name: '追踪营销新趋势，跟进热门玩法，把握客户跟你的每一次接触'
          },
          {
            name: '精细化管理会员，提升客单和复购'
          }
        ],
        painList: [
          {
            icon: require("@/assets/product/svgIcon/pain-spot-6.svg"),
            name: '获客难',
            imgShow: false,
            descList: [
              '三方平台获客成本高，平台费用、佣金、排名竞价持续白热化，盈利越来越困难',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/pain-spot-11.svg"),
            name: '转换难',
            imgShow: false,
            descList: [
              '难以借力社群、社交媒体、直播平台进行有效的传播',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/pain-spot-12.svg"),
            name: '留存难',
            imgShow: false,
            descList: [
              '新的数据安全要求，无法将平台客户进行私有化管理，全触点交互存在困难，难以低成本的进行复购转化',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/pain-spot-13.svg"),
            name: '全渠道体验构建难',
            imgShow: false,
            descList: [
              '线上线下商品、价格、服务、权益存在差异，难以实现用户安心购买',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/pain-spot-14.svg"),
            name: '数字化渠道构建难',
            imgShow: false,
            descList: [
              '繁复的渠道利益机制与倡导用户直联的数字化业务模式，形成业务冲突，数字化业务推行层层受阻',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/pain-spot-8.svg"),
            name: '数字化业务推行难',
            imgShow: false,
            descList: [
              '缺乏统筹和赋能体系的数字化业务，难以实现规模化、持续性的推行与效果',
            ]
          }
        ],
        cardStyle: {
          width: '224px',
          height: '220px',
          padding: '30px 20px 0 20px',
          marginBottom: '0px'
        },
        serviceabilityList: [
          {
            icon: require("@/assets/product/svgIcon/core-advantages-6.svg"),
            name: '全域获客',
            imgShow: false,
            descList: [
              '会员价值模型及有效的触达体系，基于用户旅程构建完整的全域触点连接方案实现海量且长效的用户获取',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/Unicom-7.svg"),
            name: '傻瓜式运营',
            imgShow: false,
            descList: [
              '提供丰富的运营素材（包含图片、视频等），适配各种行业的页面模板，可快速、无门槛的运营',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/core-advantages-5.svg"),
            name: '多模式运营',
            imgShow: false,
            descList: [
              '支持商家入驻+平台自营多种运营模式，入驻服务年费、商品销售佣金等多种盈利方式',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/Unicom-6.svg"),
            name: '定向营销',
            imgShow: false,
            descList: [
              '基于用户个体需求，实行千人千策营销策路，为每个用户提供所需且极致的用户体验',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/Unicom-8.svg"),
            name: '商品上架',
            imgShow: false,
            descList: [
              '灵活的产品参数，全行业产品支持、特别是对于工业配件以及工业品多参数的用户筛选和销售上，灵活设置',
            ]
          },
          {
            icon: require("@/assets/product/svgIcon/Unicom-9.svg"),
            name: '全息洞察',
            imgShow: false,
            descList: [
              '设定标签体系，构建用户全渠道画像布局，实现可实时感知的用户需求及用户资产沉淀',
            ]
          }
        ],
        serviceabilityStyle: {
          width: '380px',
          height: '210px',
          padding: '30px 40px 0 40px',
          marginBottom: '30px'
        },
        CarouselList: [{
          url: require('@/assets/product/digitalSystem/carousel-1.png'),
        },{
          url: require('@/assets/product/digitalSystem/carousel-2.png'),
        },{
          url: require('@/assets/product/digitalSystem/carousel-3.png'),
        }]
      }
   },
   created(){
   },
   computed:{
   },
   methods:{
   },
}
</script>
<style lang="less" scoped>
.page-box {
  background-color: #fff;
}
.bg-color-EAF1FA {
  background-color: #EAF1FA;
}
.flex-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.top-banner-tips{
  display: flex;
  margin-bottom: 15px;
}
.top-banner-tips-item {
  font-size: 14px;
  color: #3E4755;
  line-height: 14px;
  padding-right: 15px;
  margin-right: 15px;
  border-right: 1px solid #3E4755;
}
.top-banner-tips .top-banner-tips-item:last-child {
  border-right: none;
}
.mg-bottom-70 {
  margin-bottom: 70px;
}
/* 图文导航 */
.image-text-item {
  display: flex;
}
.image-text-item-left {
  background-repeat: no-repeat;
  background-size: auto 100%;
  background-position: center;
  width: 468px;
  height: 220px;
  text-align: left;
  font-size: 14px;
  color: #FFFFFF;
  line-height: 20px;
  padding: 37px 0 0 30px;
  margin-right: 20px;
}
.title-text {
  font-weight: bold;
  font-size: 22px;
  color: #FFFFFF;
  line-height: 32px;
}
.pd-bottom-90 {
  padding-bottom: 90px;
}
/* 零售商城具备完善的服务能力 */
.barrier-background {
  width: 100%;
  min-width: 1200px;
  background-repeat: no-repeat;
  background-size: 1920px 100%;
  background-position: center;
}
.pd-top-70 {
  padding-top: 70px;
}
/* 推广获客：客户在哪里，店就开到哪里 */
.goods-manage-ilne {
  display: flex;
  text-align: left;
  font-size: 14px;
  color: #595859;
  line-height: 22px;
}
.item-ilne-icon {
  width: 22px;
  height: 16px;
  margin-right: 10px;
}
.item-ilne-title {
  display: inline-block;
  font-weight: bold;
  font-size: 22px;
  color: #222222;
  line-height: 22px;
  margin-bottom: 14px;
}
.item-ilne-content {
  width: 350px;
}
.goods-manage-mid-img {
  width: 801px;
  height: 494px;
  margin-right: 34px;
}
.goods-manage-mid-img-w738{
  width: 738px;
  height: 467px;
  margin-right: 34px;
}
.goods-manage-item {
  box-sizing: border-box;
  height: 480px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 58px 0;
}
.justify-center-start {
  justify-content: flex-start;
}
/* 会员体系打造 等级成长持续活跃 */
.active-item {
  width: 580px;
  height: 430px;
  background: #FFFFFF;
  border-radius: 10px;
  overflow: hidden;
  padding: 40px 40px 0 40px;
  text-align: left;
  font-size: 14px;
  color: #595859;
  line-height: 22px;
}
.active-item-title {
  font-weight: bold;
  font-size: 22px;
  color: #222222;
  line-height: 22px;
  margin-bottom: 14px;
}
.active-item-img {
  width: 500px;
  height: 280px;
  margin-top: 30px;
}
.border-shadow {
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.08);
}
/* 一键美化，轻松运营！打造专属您的线上商城！ */
.Carousel-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: left;
}
.Carousel-item-title {
  font-size: 24px;
  color: #222222;
  line-height: 46px;
  margin-bottom: 50px;
}
.mg-bottom-50 {
  margin-bottom: 50px;
}
.Carousel-right, .Carousel-img {
  width: 650px;
  height: 550px;
}
.pd-bottom-100 {
  padding-bottom: 100px;
}
</style>
